import { render, staticRenderFns } from "./StaffTransactions.vue?vue&type=template&id=16258e12"
import script from "./StaffTransactions.vue?vue&type=script&lang=js"
export * from "./StaffTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports